import React from "react";
//  <span className="close-icon" onClick={props.handleClose}>x</span>
//  <div className="box"></div>
const Popup = props => {
  return (
    <div className="popup-box" onClick={props.handleClose}>


        {props.content}
      </div>

  );
};

export default Popup;
